module.exports = __webpack_public_path__ + "img/Group 325.6c35b93b.png";